import React, { useEffect } from 'react';

export default function Modal({ open, onClose, title, children, footer, className = '' }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="sp-modal-overlay" onClick={onClose} role="presentation">
      <div
        className={`sp-modal ${className}`.trim()}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? 'sp-modal-title' : undefined}
      >
        <div className="sp-modal__accent" />
        {title && <h2 id="sp-modal-title" className="sp-modal__title">{title}</h2>}
        <div>{children}</div>
        {footer && <div style={{ marginTop: 24, display: 'flex', gap: 12, justifyContent: 'flex-end' }}>{footer}</div>}
      </div>
    </div>
  );
}
